var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print__report__header"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('img',{staticClass:"print__report__logo",attrs:{"src":_vm.companyLogoUrl || _vm.logo,"alt":_vm.pageTitle}})]),_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('div',{staticClass:"client__name"},[_vm._v(_vm._s(_vm.clientName))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }